import {useState} from 'react'

function ForgotPassword({onClose}) {
    const [mobile,setMobile] = useState("");
    const [sent,setSent] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">

      {/* Modal Card */}
        <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl dark:bg-[#151b2b]">

        {/* Header */}
         <div className="mb-4 flex justify-between items-center">
          <h2 className="text-xl font-bold text-text-main dark:text-white">
            Forgot Password
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600">✕
          </button>
         </div>
        {!sent ? (
            <>
            <p className="mb-4 text-sm text-text-sub dark:text-gray-400">
              Enter your registered mobile number. We’ll send you an OTP to reset your password.
            </p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <input value={mobile} type="tel" placeholder="Enter your mobile number" onChange={(e) => setMobile(e.target.value)}
            className="h-12 rounded-xl border border-[#e7ebf4] bg-[#f8f9fc] px-4 text-base focus:outline-none focus:ring-2 focus:ring-[#0d59f2]/20 focus:border-[#0d59f2] dark:bg-[#101622] dark:border-slate-700 dark:text-white"
                required/>
            <button
                type="submit"
                className="h-12 rounded-xl bg-[#0d59f2] text-white font-semibold hover:bg-[#0b4bc9] transition">Send OTP</button>
        </form> 
        </>) : (<div className="text-center">
            <p className="text-lg font-semibold text-green-600 mb-2">
              OTP Sent Successfully!
            </p>
            <p className="text-sm text-text-sub dark:text-gray-400 mb-6">
              Please check your phone.
            </p>
            <button onClick={onClose} className="w-full h-12 rounded-xl bg-[#0d59f2] text-white font-semibold hover:bg-[#0b4bc9]" >Back to Login</button>
            </div>)
        }
        </div>
    </div>
  )
}

export default ForgotPassword